import { Unit_instance28fytmsmm6r23 as Unit_instance } from '../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { LinkedHashMap1zhqxkxv3xnkl as LinkedHashMap } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/LinkedHashMap.mjs';
import { caseInsensitiveMap1xhpwzg797p51 as caseInsensitiveMap } from './Collections.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import {
  KtMap140uvy3s5zad8 as KtMap,
  Entry2xmjmyutzoq3p as Entry,
} from '../../../../kotlin-kotlin-stdlib/kotlin/collections/Collections.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { unmodifiable2pi9okt3ceep6 as unmodifiable } from './Collections.web.mjs';
import {
  firstOrNull1982767dljvdy as firstOrNull,
  toSet2orjxp16sotqu as toSet,
} from '../../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
import { addAll1k27qatfgp3k5 as addAll } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/MutableCollections.mjs';
import { emptySetcxexqki71qfa as emptySet } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/Sets.mjs';
import {
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  initMetadataForInterface1egvbzx539z91 as initMetadataForInterface,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { emptyMapr06gerzljqtm as emptyMap } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/Maps.mjs';
import {
  toString1pkumu07cwy4m as toString,
  getBooleanHashCode1bbj3u6b3v0a7 as getBooleanHashCode,
  equals2au1ep9vhcato as equals,
  getStringHashCode26igk1bx568vk as getStringHashCode,
  hashCodeq5arwsb9dgti as hashCode,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { equals2v6cggk171b6e as equals_0 } from '../../../../kotlin-kotlin-stdlib/kotlin/text/stringsCode.mjs';
import { setOf1u3mizs95ngxo as setOf } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/collectionJs.mjs';
import { collectionSizeOrDefault36dulx8yinfqm as collectionSizeOrDefault } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/Iterables.mjs';
import { to2cs3ny02qtbcb as to } from '../../../../kotlin-kotlin-stdlib/kotlin/Tuples.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
function appendAll(_this__u8e3s4, builder) {
  // Inline function 'kotlin.apply' call
  // Inline function 'kotlin.collections.forEach' call
  var _iterator__ex2g4s = builder.h4o().u1();
  while (_iterator__ex2g4s.v1()) {
    var element = _iterator__ex2g4s.w1();
    // Inline function 'kotlin.collections.component1' call
    var name = element.r3();
    // Inline function 'kotlin.collections.component2' call
    var values = element.s3();
    _this__u8e3s4.i4o(name, values);
  }
  return _this__u8e3s4;
}
function ensureListForKey($this, name) {
  var tmp0_elvis_lhs = $this.k4o_1.z4(name);
  var tmp;
  if (tmp0_elvis_lhs == null) {
    // Inline function 'kotlin.collections.mutableListOf' call
    // Inline function 'kotlin.also' call
    var this_0 = ArrayList().u2();
    $this.l4o(name);
    // Inline function 'kotlin.collections.set' call
    $this.k4o_1.c5(name, this_0);
    tmp = this_0;
  } else {
    tmp = tmp0_elvis_lhs;
  }
  return tmp;
}
var StringValuesBuilderImplClass;
function StringValuesBuilderImpl() {
  if (StringValuesBuilderImplClass === VOID) {
    class $ {
      constructor(caseInsensitiveName, size) {
        caseInsensitiveName = caseInsensitiveName === VOID ? false : caseInsensitiveName;
        size = size === VOID ? 8 : size;
        this.j4o_1 = caseInsensitiveName;
        this.k4o_1 = this.j4o_1 ? caseInsensitiveMap() : LinkedHashMap().hc(size);
      }
      m4o() {
        return this.j4o_1;
      }
      n4o(name) {
        return this.k4o_1.z4(name);
      }
      o4o(name) {
        // Inline function 'kotlin.collections.contains' call
        // Inline function 'kotlin.collections.containsKey' call
        var this_0 = this.k4o_1;
        return (isInterface(this_0, KtMap()) ? this_0 : THROW_CCE()).x4(name);
      }
      p4o() {
        return this.k4o_1.a5();
      }
      s1() {
        return this.k4o_1.s1();
      }
      h4o() {
        return unmodifiable(this.k4o_1.q3());
      }
      q4o(name, value) {
        this.r4o(value);
        var list = ensureListForKey(this, name);
        list.f5();
        list.n2(value);
      }
      w2o(name) {
        var tmp0_safe_receiver = this.n4o(name);
        return tmp0_safe_receiver == null ? null : firstOrNull(tmp0_safe_receiver);
      }
      s4o(name, value) {
        this.r4o(value);
        ensureListForKey(this, name).n2(value);
      }
      t4o(stringValues) {
        stringValues.u4o((name, values) => {
          this.i4o(name, values);
          return Unit_instance;
        });
      }
      i4o(name, values) {
        // Inline function 'kotlin.let' call
        var list = ensureListForKey(this, name);
        // Inline function 'kotlin.collections.forEach' call
        var _iterator__ex2g4s = values.u1();
        while (_iterator__ex2g4s.v1()) {
          var element = _iterator__ex2g4s.w1();
          this.r4o(element);
        }
        addAll(list, values);
      }
      v4o(name, values) {
        var tmp0_safe_receiver = this.k4o_1.z4(name);
        var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : toSet(tmp0_safe_receiver);
        var existing = tmp1_elvis_lhs == null ? emptySet() : tmp1_elvis_lhs;
        // Inline function 'kotlin.collections.filter' call
        // Inline function 'kotlin.collections.filterTo' call
        var destination = ArrayList().u2();
        var _iterator__ex2g4s = values.u1();
        while (_iterator__ex2g4s.v1()) {
          var element = _iterator__ex2g4s.w1();
          if (!existing.y2(element)) {
            destination.n2(element);
          }
        }
        this.i4o(name, destination);
      }
      w4o(name) {
        this.k4o_1.d5(name);
      }
      f5() {
        this.k4o_1.f5();
      }
      l4o(name) {
      }
      r4o(value) {
      }
    }
    initMetadataForClass($, 'StringValuesBuilderImpl', StringValuesBuilderImpl);
    StringValuesBuilderImplClass = $;
  }
  return StringValuesBuilderImplClass;
}
function get(name) {
  var tmp0_safe_receiver = this.n4o(name);
  return tmp0_safe_receiver == null ? null : firstOrNull(tmp0_safe_receiver);
}
function forEach(body) {
  // Inline function 'kotlin.collections.forEach' call
  var _iterator__ex2g4s = this.h4o().u1();
  while (_iterator__ex2g4s.v1()) {
    var element = _iterator__ex2g4s.w1();
    // Inline function 'kotlin.collections.component1' call
    var k = element.r3();
    // Inline function 'kotlin.collections.component2' call
    var v = element.s3();
    body(k, v);
  }
  return Unit_instance;
}
var StringValuesClass;
function StringValues() {
  if (StringValuesClass === VOID) {
    class $ {}
    initMetadataForInterface($, 'StringValues');
    StringValuesClass = $;
  }
  return StringValuesClass;
}
function listForKey($this, name) {
  return $this.y4o_1.z4(name);
}
var StringValuesImplClass;
function StringValuesImpl() {
  if (StringValuesImplClass === VOID) {
    class $ {
      constructor(caseInsensitiveName, values) {
        caseInsensitiveName = caseInsensitiveName === VOID ? false : caseInsensitiveName;
        values = values === VOID ? emptyMap() : values;
        this.x4o_1 = caseInsensitiveName;
        var tmp;
        if (this.x4o_1) {
          tmp = caseInsensitiveMap();
        } else {
          // Inline function 'kotlin.collections.mutableMapOf' call
          tmp = LinkedHashMap().gc();
        }
        var newMap = tmp;
        // Inline function 'kotlin.collections.forEach' call
        // Inline function 'kotlin.collections.iterator' call
        var _iterator__ex2g4s = values.q3().u1();
        while (_iterator__ex2g4s.v1()) {
          var element = _iterator__ex2g4s.w1();
          // Inline function 'kotlin.collections.component1' call
          var key = element.r3();
          // Inline function 'kotlin.collections.component2' call
          var value = element.s3();
          // Inline function 'kotlin.collections.List' call
          // Inline function 'kotlin.collections.MutableList' call
          var size = value.v2();
          var list = ArrayList().m2(size);
          // Inline function 'kotlin.repeat' call
          var inductionVariable = 0;
          if (inductionVariable < size)
            do {
              var index = inductionVariable;
              inductionVariable = inductionVariable + 1 | 0;
              var tmp$ret$4 = value.w2(index);
              list.n2(tmp$ret$4);
            }
             while (inductionVariable < size);
          // Inline function 'kotlin.collections.set' call
          newMap.c5(key, list);
        }
        this.y4o_1 = newMap;
      }
      m4o() {
        return this.x4o_1;
      }
      w2o(name) {
        var tmp0_safe_receiver = listForKey(this, name);
        return tmp0_safe_receiver == null ? null : firstOrNull(tmp0_safe_receiver);
      }
      n4o(name) {
        return listForKey(this, name);
      }
      p4o() {
        return unmodifiable(this.y4o_1.a5());
      }
      s1() {
        return this.y4o_1.s1();
      }
      h4o() {
        return unmodifiable(this.y4o_1.q3());
      }
      u4o(body) {
        // Inline function 'kotlin.collections.iterator' call
        var _iterator__ex2g4s = this.y4o_1.q3().u1();
        while (_iterator__ex2g4s.v1()) {
          var _destruct__k2r9zo = _iterator__ex2g4s.w1();
          // Inline function 'kotlin.collections.component1' call
          var key = _destruct__k2r9zo.r3();
          // Inline function 'kotlin.collections.component2' call
          var value = _destruct__k2r9zo.s3();
          body(key, value);
        }
      }
      toString() {
        return 'StringValues(case=' + !this.x4o_1 + ') ' + toString(this.h4o());
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(!(other == null) ? isInterface(other, StringValues()) : false))
          return false;
        if (!(this.x4o_1 === other.m4o()))
          return false;
        return entriesEquals(this.h4o(), other.h4o());
      }
      hashCode() {
        return entriesHashCode(this.h4o(), imul(31, getBooleanHashCode(this.x4o_1)));
      }
    }
    initMetadataForClass($, 'StringValuesImpl', StringValuesImpl, VOID, [StringValues()]);
    StringValuesImplClass = $;
  }
  return StringValuesImplClass;
}
var StringValuesSingleImpl$entries$1Class;
function StringValuesSingleImpl$entries$1() {
  if (StringValuesSingleImpl$entries$1Class === VOID) {
    class $ {
      constructor(this$0) {
        this.z4o_1 = this$0.c4p_1;
        this.a4p_1 = this$0.d4p_1;
      }
      r3() {
        return this.z4o_1;
      }
      s3() {
        return this.a4p_1;
      }
      toString() {
        return this.z4o_1 + '=' + toString(this.a4p_1);
      }
      equals(other) {
        var tmp;
        var tmp_0;
        if (!(other == null) ? isInterface(other, Entry()) : false) {
          tmp_0 = equals(other.r3(), this.z4o_1);
        } else {
          tmp_0 = false;
        }
        if (tmp_0) {
          tmp = equals(other.s3(), this.a4p_1);
        } else {
          tmp = false;
        }
        return tmp;
      }
      hashCode() {
        return getStringHashCode(this.z4o_1) ^ hashCode(this.a4p_1);
      }
    }
    initMetadataForClass($, VOID, VOID, VOID, [Entry()]);
    StringValuesSingleImpl$entries$1Class = $;
  }
  return StringValuesSingleImpl$entries$1Class;
}
var StringValuesSingleImplClass;
function StringValuesSingleImpl() {
  if (StringValuesSingleImplClass === VOID) {
    class $ {
      constructor(caseInsensitiveName, name, values) {
        this.b4p_1 = caseInsensitiveName;
        this.c4p_1 = name;
        this.d4p_1 = values;
      }
      m4o() {
        return this.b4p_1;
      }
      n4o(name) {
        return equals_0(this.c4p_1, name, this.m4o()) ? this.d4p_1 : null;
      }
      h4o() {
        return setOf(new (StringValuesSingleImpl$entries$1())(this));
      }
      s1() {
        return false;
      }
      p4o() {
        return setOf(this.c4p_1);
      }
      toString() {
        return 'StringValues(case=' + !this.m4o() + ') ' + toString(this.h4o());
      }
      hashCode() {
        return entriesHashCode(this.h4o(), imul(31, getBooleanHashCode(this.m4o())));
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(!(other == null) ? isInterface(other, StringValues()) : false))
          return false;
        if (!(this.m4o() === other.m4o()))
          return false;
        return entriesEquals(this.h4o(), other.h4o());
      }
      u4o(body) {
        return body(this.c4p_1, this.d4p_1);
      }
      w2o(name) {
        return equals_0(name, this.c4p_1, this.m4o()) ? firstOrNull(this.d4p_1) : null;
      }
    }
    initMetadataForClass($, 'StringValuesSingleImpl', VOID, VOID, [StringValues()]);
    StringValuesSingleImplClass = $;
  }
  return StringValuesSingleImplClass;
}
function entriesEquals(a, b) {
  return equals(a, b);
}
function entriesHashCode(entries, seed) {
  return imul(seed, 31) + hashCode(entries) | 0;
}
function flattenEntries(_this__u8e3s4) {
  // Inline function 'kotlin.collections.flatMap' call
  var tmp0 = _this__u8e3s4.h4o();
  // Inline function 'kotlin.collections.flatMapTo' call
  var destination = ArrayList().u2();
  var _iterator__ex2g4s = tmp0.u1();
  while (_iterator__ex2g4s.v1()) {
    var element = _iterator__ex2g4s.w1();
    // Inline function 'kotlin.collections.map' call
    var this_0 = element.s3();
    // Inline function 'kotlin.collections.mapTo' call
    var destination_0 = ArrayList().m2(collectionSizeOrDefault(this_0, 10));
    var _iterator__ex2g4s_0 = this_0.u1();
    while (_iterator__ex2g4s_0.v1()) {
      var item = _iterator__ex2g4s_0.w1();
      var tmp$ret$0 = to(element.r3(), item);
      destination_0.n2(tmp$ret$0);
    }
    var list = destination_0;
    addAll(destination, list);
  }
  return destination;
}
//region block: exports
export {
  forEach as forEachghjt92rkrpzo,
  get as get3oezx9z3zutmm,
  StringValuesBuilderImpl as StringValuesBuilderImpl3ey9etj3bwnqf,
  StringValuesImpl as StringValuesImpl2l95y9du7b61t,
  StringValuesSingleImpl as StringValuesSingleImpl1uh7q2c2zm7va,
  StringValues as StringValuesjqid5a6cuday,
  appendAll as appendAlltwnjnu28pmtx,
  flattenEntries as flattenEntries2zw7fl55k6a0l,
};
//endregion

//# sourceMappingURL=StringValues.mjs.map
